import { render, staticRenderFns } from "./PluginInfoPanel.vue?vue&type=template&id=297b3958&scoped=true&"
import script from "./PluginInfoPanel.vue?vue&type=script&lang=js&"
export * from "./PluginInfoPanel.vue?vue&type=script&lang=js&"
import style0 from "./PluginInfoPanel.vue?vue&type=style&index=0&id=297b3958&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297b3958",
  null
  
)

export default component.exports